export default __webpack_public_path__ + "static/media/application-screenshots-05.ec970e78.jpg";